const SvgBusinessAutomation1 = (props) => (
  <>
    <defs />
    <path
      id="b"
      d="m336 240 48-48-48-48m-96 48h144m-240 0H0"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      d="M0 144V47.73C0 21.37 21.49 0 48 0s48 21.37 48 47.73V144M96 240l.06 96.23c0 26.38 21.5 47.77 47.92 47.77S192 362.13 192 335.75V192M288 240v96.2c0 26.4 21.43 47.8 47.87 47.8S384 362.6 384 336.2V288M192 191.81V47.64C192 21.33 213.49 0 240 0s48 21.33 48 47.64V144"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cy={192} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cy={192} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgBusinessAutomation1;
